// src/features/availability/availabilitySlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AvailabilityStatusResponse } from "@core/api/memberApi"

interface AvailabilityState {
  isToken: boolean
  isTrial: boolean
  isAvailable: boolean
  remainDays: number
  loaded: boolean
}

const initialState: AvailabilityState = {
  isToken: false,
  isTrial: false,
  isAvailable: true,
  remainDays: 0,
  loaded: false,
}

const availabilitySlice = createSlice({
  name: "availability",
  initialState,
  reducers: {
    setAvailabilityStatus: (state, action: PayloadAction<AvailabilityStatusResponse>) => {
      state.isToken = action.payload.isToken
      state.isTrial = action.payload.isTrial
      state.isAvailable = action.payload.isAvailable
      state.remainDays = action.payload.remainDays
      state.loaded = true
    },
    resetAvailabilityStatus: state => {
      return initialState
    },
  },
})

export const { setAvailabilityStatus, resetAvailabilityStatus } = availabilitySlice.actions
export default availabilitySlice.reducer
